const escapeDoubleQuotes = (string) => {
	let val = string.replace(/[\u00A0-\u9999<>]^[a-zA-Z àâäèéêëîïôœùûüÿçÀÂÄÈÉÊËÎÏÔŒÙÛÜŸÇ]+$/g, function (i) {
		return "&#" + i.charCodeAt(0) + ";";
	});
	return val;
};

export default escapeDoubleQuotes;
